<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <g>
    <g>
      <circle class="filled" cx="32" cy="20.138" r="10.092" fill="currentColor"/>
      <path class="filled" d="M32,34.879A19.08,19.08,0,0,0,13.173,50.87a2.687,2.687,0,0,0,2.672,3.084h32.31a2.687,2.687,0,0,0,2.672-3.084A19.08,19.08,0,0,0,32,34.879Z" fill="currentColor"/>
    </g>
    <rect width="64" height="64" fill="none"/>
  </g>
</svg>
